// extracted by mini-css-extract-plugin
export default {"consent":"legalConsent_consent__pupx5","consentText":"legalConsent_consentText__-xXqd"};